// SPDX-License-Identifier: AGPL-3.0-or-later

export const SETTINGS_FADE_VARIANTS = {enter: {opacity: 0}, center: {opacity: 1}, exit: {opacity: 0}};
